import AuAdmin from "./admin";

const App = () => <AuAdmin />;

export default App;
